import { Observable } from 'rxjs';

import { LabelType } from '../../../../../elements/components/label/entities/label-type.entity';
import { Cell, CellType } from '../_base/table-cell.entity';

export class AsyncStatusCell<T> extends Cell {
    constructor(
        public readonly asyncData: Observable<T>,
        public readonly labelFactory: (data: T) => string,
        public readonly labelTypeFactory: (data: T) => LabelType,
        public readonly useProgressFactory: (data: T) => boolean,
        public readonly percentage: number = 0,
        public readonly placeholderLabel: string,
        public readonly placeholderLabelType: LabelType
    ) {
        super(CellType.ASYNC_STATUS);
    }
}
